<template>
  <div v-if="user" style="display: flex; align-items: center">
    <template v-if="tags.length">
      <v-chip class="ma-1" color="primary" text-color="white" small>
        {{ tags[tags.length - 1] }}
      </v-chip>
      <template v-if="tags.length > 1">
        <v-dialog v-model="showDialogTags" width="400px" scrollable>
          <v-card>
            <v-card-title style="display: flex; justify-content: space-between">
              <span class="headline">Tags</span>
              <v-btn icon small @click.stop="showDialogTags = false">
                <v-icon small>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-chip
                v-for="(tag, index) in tags"
                :key="index"
                class="ma-1"
                color="primary"
                text-color="white"
              >
                {{ tag }}
              </v-chip>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-btn icon small outline @click.stop="showDialogTags = true">
          <v-icon small>more_vert</v-icon>
        </v-btn>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: ['user'],
  data() {
    return {
      showDialogTags: false
    }
  },
  computed: {
    tags() {
      let tags = []
      if (this.user) {
        if (typeof this.user.tags === 'string') {
          tags = this.user.tags.split(',')
        } else {
          tags = this.user.tags || []
        }
      }
      return tags.filter(Boolean)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-user-item-tags.vue